import request from '../untils/request';

export const loginApi = params => {
  return request({
    url: '/system/user/login',
    params,
  });
};

export const wechatLoginInfoApi = params => {
  return request({
    url: '/system/user/wechat-login-info',
    params,
  });
};

export const wechatLoginCheckApi = params => {
  return request({
    url: '/system/user/wechat-login',
    params,
  });
};

export const passwordsResetApi = params => {
  return request({
    url: '/system/user/password-change',
    params,
  });
};